import { CachedSamplingConfig } from './cached-sampling-config';
export var cache = new CachedSamplingConfig();